module.exports = __webpack_public_path__ + "static/media/procedure.f755ae80.svg";